import React from "react";
import { Link } from "react-router-dom";
import defaultImg from "../../../../assets/img/thumbnail.png";
import { useState } from "react";
import {
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { useEffect } from "react";
import MoonLoader from "react-spinners/MoonLoader";

export default function Shippingpages() {
  const [Image, setImage] = useState("");
  const [LocalImgPath, setLocalImgPath] = useState("");
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    PostService(API_URL.GET_SHIPPING_PAGE_DETAIL, {}).then((res) => {
      console.log(res);
      if (res.data.status === true) {
        // setImage(res.data.data?.image);
        setLocalImgPath(
          res.data.data?.image ? res.data.data?.image : defaultImg
        );
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  }, []);

  const onimageUpload = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setLocalImgPath(window.URL.createObjectURL(e.target.files[0]));
    }
  };

  function uploadImage(e) {
    e.preventDefault();
    if (!Image) {
      setError(true);
      return;
    }
    setsubmitLoader(true);

    let formdata = new FormData();
    formdata.append("image", Image);
    formdata.append("id", '1');

    PostFormData(API_URL.UPDATE_SHIPPING, formdata).then((res) => {
      console.log(res);
      if (res.data.status === true) {
        showSuccessAlert(res?.data?.message); 
      } else {
        showErrorAlert(res.data?.message);
      }
      setError(false);
        setsubmitLoader(false);
    });
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Shipping Page</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Shipping Page</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                 
                  <>
                  <div className="row">
                    <div className="col-md-6">
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => onimageUpload(e)}
                      />
                      {error && !Image &&(
                        <div className="error mt-1">Please select Image!</div>
                      )}
                    </div>
                    <div className="col-md-3 pl-0">
                      <button
                        className="btn btn-primary"
                        onClick={uploadImage}
                        disabled={submitLoader}
                      >
                        {submitLoader ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          "Upload Image"
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="mt-4 offset-md-1">
                      <img
                        src={LocalImgPath}
                        alt="..."
                        style={{
                          height: "350px",
                          width: "300px",
                          borderRadius: "10px",
                        }}
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                    </div>
                  </div>
                  </>
                
                   {loading ? (
                     <div className="LoaderSpinner">
                        <MoonLoader
                       color={"#003bff"}
                       loading={loading}
                       speedMultiplier={0.6}
                       size={50}
                     />
                       <div>Loading... Please wait.</div>
                     </div>
                   ) : (
                     ""
                       )}    
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
